/* eslint-disable no-undef */

//import {slideUp, slideDown, slideToggle} from './_slideElement.js';

document.addEventListener('DOMContentLoaded', function () {
  /* */
  /* Get started — 2nd step START */
  const inputs = document.querySelectorAll('.js-get-started-input');
  const inputsTwins = [];
  const inputsPayment = [];
  const depositVal = 150;
  const feeVal = 150;
  const displayEls = {
    twins: document.querySelector('.js-twins-display-value'),
    deposit: document.querySelector('.js-deposit-display-value'),
    fee: document.querySelector('.js-fee-display-value'),
    total: document.querySelector('.js-total-display-value')
  }

  if (inputs) {
    inputs.forEach((input) => {
      if (input.matches('[name="expecting twins"]')) {
        inputsTwins.push(input);
      }
      if (input.matches('[name="payment plan"]')) {
        inputsPayment.push(input);
      }
    });
    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        calc();
      });
    });
  }

  function formatCurrency(num) {
    return new Intl.NumberFormat('en-AU', {minimumFractionDigits: 2}).format(num)
  }

  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  function calc() {
    for (const input of inputsTwins) {
      if (input.checked) {
        displayEls.twins.textContent = input.value;
      }
    }
    for (const input of inputsPayment) {
      if (input.checked) {
        const planValue = +input.value;
        const totalVal = depositVal + feeVal + planValue;
        displayEls.deposit.textContent = formatCurrency(depositVal);
        displayEls.fee.textContent = formatCurrency(feeVal);
        displayEls.total.textContent = formatCurrency(totalVal);
      }
    }
  }
  /* Get started — 2nd step END */
  /* */

  /* */
  /* Get started — 3rd step START */
  const motherDetails = document.querySelector('.js-gr-form__mother-details');
  if (motherDetails) {
    const motherRadioYes = document.querySelector('.js-am-i-mother-radio[value="Yes"]');
    const motherRadioNo = document.querySelector('.js-am-i-mother-radio[value="No"]');
    const motherRequiredFields = motherDetails.querySelectorAll('[data-required]');
    motherRadioYes.addEventListener('change', () => {
      if (motherRadioYes.checked) {
        slideUp(motherDetails);
        motherRequiredFields.forEach(reqField => {
          reqField.removeAttribute('required');
        });
      }
    });
    motherRadioNo.addEventListener('change', () => {
      if (motherRadioNo.checked) {
        slideDown(motherDetails);
        motherRequiredFields.forEach(reqField => {
          reqField.setAttribute('required', true);
        });
      }
    });

    const motherAddress = document.querySelector('.js-mother-address');
    const motherAddressRequiredFields = motherAddress.querySelectorAll('[data-required]');
    const motherSameAddressCheck = document.querySelector('.js-mother-same-address-check');
    motherSameAddressCheck.addEventListener('change', () => {
      if (motherSameAddressCheck.checked) {
        slideUp(motherAddress);
        motherAddressRequiredFields.forEach(reqField => {
          reqField.removeAttribute('required');
        });
      } else {
        slideDown(motherAddress);
        motherAddressRequiredFields.forEach(reqField => {
          reqField.setAttribute('required', true);
        });
      }
    })
  }

  const paymentMethodsRadios = document.querySelectorAll('.js-payment-method');
  if (paymentMethodsRadios[0]) {
    const cardFields = document.querySelector('.js-gr-form__card');
    const cardRequiredFields = cardFields.querySelectorAll('[data-required]');
    const bankFields = document.querySelector('.js-gr-form__bank');
    const bankRequiredFields = bankFields.querySelectorAll('[data-required]');
    paymentMethodsRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          const radioValue = radio.value;
          if (radioValue === 'card') {
            slideDown(cardFields);
            slideUp(bankFields);
            cardRequiredFields.forEach(reqField => {
              reqField.setAttribute('required', true);
            });
            bankRequiredFields.forEach(reqField => {
              reqField.removeAttribute('required');
            });
          } else if (radioValue === 'bank') {
            slideDown(bankFields);
            slideUp(cardFields);
            bankRequiredFields.forEach(reqField => {
              reqField.setAttribute('required', true);
            });
            cardRequiredFields.forEach(reqField => {
              reqField.removeAttribute('required');
            });
          }
        }
      });
    });
  }
  /* Get started — 3rd step END */
  /* */
});
